export default "__VITE_ASSET__BXu8O68B__"